import React from "react";

import Toggle from "./Toggle";
import useDarkMode from "use-dark-mode";
// import "./styles.scss";

const DarkModeToggle = () => {
  const darkMode = useDarkMode(false);

  return (
    <div className="dark-mode-toggle">
      dark mode
      <Toggle checked={darkMode.value} onChange={darkMode.toggle} />
    </div>
  );
};

export default DarkModeToggle;
